// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='UploadingError'] {\n  color: var(--primary-style-color);\n  font-size: 12px;\n  padding-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
